/// <reference path="../include.ts" />

namespace project_common {

	import QueryString = alm.browser.QueryString;

	export class PresetContext {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(deployMode:DeployMode) {
			this.deployMode = deployMode;
			trace('[PresetContext] deployMode:', this.deployMode);

			this.langList = window['langList'];
			trace('[PresetContext] language (list) :', this.langList);

			this.lang = LangUtil.loadLanguage(this.langList);
			trace('[PresetContext] language (final) :', this.lang);

			const query = new QueryString();
			this.zoneRevision = query.getString('zone_revision', '1');
			this.isNeedUpdate = query.getBool('is_need_update', false);
			trace('[PresetContext] zoneRevision :', this.zoneRevision);
			trace('[PresetContext] isNeedUpdate :', this.isNeedUpdate);
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		public readonly deployMode:DeployMode;
		public readonly langList:Lang[];
		public readonly lang:Lang;
		public readonly zoneRevision:string;
		public readonly isNeedUpdate:boolean;
	}
}
